var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-5 text-center"},[_vm._v(" Il n'y a rien ici ")])
}
var staticRenderFns = []

export { render, staticRenderFns }